export var BATTLES_TABS = {
  GAME: 'GAME',
  STREAK: 'STREAK'
};
export var BATTLES_STANDING_TYPE = {
  PLAYER: 'PLAYER',
  BOT: 'BOT'
};
export var BATTLES_FEATURE_STATUS = {
  PENDING: 'PENDING',
  TUTORIAL: 'TUTORIAL',
  RUNNING: 'RUNNING',
  FINISHED: 'FINISHED',
  PAUSED: 'PAUSED',
  CANCELED: 'CANCELED'
};
export var BATTLES_STATES = {
  LOADING: 'LOADING',
  LOCKED: 'LOCKED',
  READY: 'READY',
  RUNNING: 'RUNNING',
  REWARD: 'REWARD',
  COMPLETED: 'COMPLETED',
  FINISHED: 'FINISHED'
};
export var BATTLES_TIMEOUT_KEYS = {
  GAME: 'BATTLES_GAME_TIMEOUT',
  STREAK: 'BATTLES_STREAK_TIMEOUT'
};
export var BATTLES_STREAK_STATES = {
  RUNNING: 'RUNNING',
  REWARD: 'REWARD',
  DISPLAY: 'DISPLAY',
  ADVANCE: 'ADVANCE'
};